import { defineStore } from 'pinia';

export const useSteperStore = defineStore('steper', {
    state: () => ({
        step: 1,
    }),
    actions: {
        setStep(newStep) {
            this.step = newStep;
        },
        nextStep() {
            if (this.step < 3) {
                this.step += 1;
            }
        },
        previousStep() {
            if (this.step > 1) {
                this.step -= 1;
            }
        }
    }
});
